export default __webpack_public_path__ + "static/media/financas2.cadbae0e.jpg";